export default [
    'Niedz',
    'Pon',
    'Wt',
    'Śr',
    'Czw',
    'Pt',
    'Sob',
];
